import React, { createContext, ReactNode, useContext, useState } from 'react'
import { useHostPortalContext } from './HostPortalContext';
import { Host } from '../models/hostModel';

interface NavigationMessageContextType {
    message: string | undefined;
    setMessage: (ms: string) => void;
    host?: Host;
}

const NavigationMessageContext = createContext<NavigationMessageContextType | undefined>(undefined);

export const NavigationMessageContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const { host } = useHostPortalContext();
    const [message, setMessage] = useState<string>();

    return (
        <NavigationMessageContext.Provider value={{ message, setMessage, host }}>
            {children}
        </NavigationMessageContext.Provider>
    );
};

//custom hook to use the context
export const useNavigationMessageContext = (): NavigationMessageContextType => {
    const context = useContext(NavigationMessageContext);
    if(!context)
        throw new Error("useNavigationMessageContext must be used within a provider");

    return context;
}


